import { render, staticRenderFns } from "./RiskAttributesModal.vue?vue&type=template&id=71933524&scoped=true"
import script from "./RiskAttributesModal.vue?vue&type=script&lang=js"
export * from "./RiskAttributesModal.vue?vue&type=script&lang=js"
import style0 from "./RiskAttributesModal.vue?vue&type=style&index=0&id=71933524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71933524",
  null
  
)

export default component.exports